import React from "react"
import { Link } from "gatsby"
import Hamburger from "./Hamburger"
import Spring from "../components/Spring"
import GithubIcon from "../images/github.png"
import LinkedinIcon from "../images/linkedin-icon.png"
import MediumIcon from "../images/medium.webp"
import NpmIcon from "../images/npm.png"
// A 192px derivative of the canonical mark. The full-size original stays the
// favicon and Open Graph source, but the header only ever renders it small, and
// shipping the 956KB master on every page load bought nothing.
import BrandMark from "../images/nic-barnes-logo-192.png"
import { SiBuymeacoffee } from "react-icons/si"
import "./header.css"

// Define the props interface for the Header component
interface HeaderProps {
  /** The title of the site to display in the header */
  siteTitle?: string
  /** Whether the navigation menu is currently open */
  navOpen: boolean
  /** Function to toggle the navigation menu state */
  setNavOpen: (isOpen: boolean) => void
  /** Center the social row (used on the full-bleed atlas so it clears the atlas's own top-left title) */
  atlas?: boolean
}

/**
 * Header component that displays the site title, social media icons, and navigation
 * @param props - The component props
 * @returns JSX element for the header
 */
const Header: React.FC<HeaderProps> = ({
  navOpen,
  setNavOpen,
  atlas = false,
}) => {
  return (
    <header>
      <div className="header-container">
        <div
          style={
            atlas
              ? { display: "flex", flex: 1, justifyContent: "center" }
              : { display: "flex" }
          }
        >
          <Spring isTitle>
            <div style={{ display: "flex", alignSelf: "center" }}>
              <Link
                to="/"
                className={`brand-home-link${atlas ? " brand-home-link--atlas" : ""}`}
                aria-label="Home"
              >
                <img className="brand-mark" src={BrandMark} alt="" />
              </Link>
            </div>
          </Spring>
          <Spring isTitle={false}>
            <a
              href="https://github.com/colorpulse6"
              target="_blank"
              rel="noopener noreferrer"
              data-tooltip="GitHub"
            >
              <img
                className="icons"
                src={GithubIcon}
                alt="GitHub profile link"
              />
            </a>
          </Spring>
          <Spring isTitle={false}>
            <a
              href="https://www.linkedin.com/in/nic-barnes-a3297217/"
              target="_blank"
              rel="noopener noreferrer"
              data-tooltip="LinkedIn"
            >
              <img
                className="icons"
                src={LinkedinIcon}
                alt="LinkedIn profile link"
              />
            </a>
          </Spring>
          <Spring isTitle={false}>
            <a
              href="https://medium.com/@colorpulse_6839"
              target="_blank"
              rel="noopener noreferrer"
              data-tooltip="Medium"
            >
              <img className="icons" src={MediumIcon} alt="Medium link" />
            </a>
          </Spring>
          <Spring isTitle={false}>
            <a
              href="https://www.npmjs.com/~colorpulse"
              target="_blank"
              rel="noopener noreferrer"
              data-tooltip="npm"
            >
              <img className="icons" src={NpmIcon} alt="NPM link" />
            </a>
          </Spring>
          <Spring isTitle={false}>
            <a
              href="https://buymeacoffee.com/nicbarnes"
              target="_blank"
              rel="noopener noreferrer"
              data-tooltip="Buy me a coffee"
              aria-label="Buy me a coffee"
            >
              <SiBuymeacoffee
                className="icons"
                style={{ background: "#ffdd00", color: "#0a0a0a", height: "auto" }}
              />
            </a>
          </Spring>
        </div>
        <Spring isTitle={false}>
          <Hamburger navOpen={navOpen} setNavOpen={setNavOpen} />
        </Spring>
      </div>
    </header>
  )
}

export default Header
